import { SelectProps } from '@mantine/core';
import { Select } from 'src/design/atoms/Select';
import React from 'react';
import { useDocumentTemplates } from 'src/api/queries/documentTemplates/useDocumentTemplates';

export interface IDocumentTemplateSelectorProps
  extends Omit<SelectProps, 'data'> {
  value: string | null;
  onChange: (value: string | null) => void;
}

/** @registry Select dropdown of document (folder) templates, used when creating/editing a job. */
export const DocumentTemplateSelector: React.FC<
  IDocumentTemplateSelectorProps
> = ({
  value,
  onChange,
  label = 'Document Template',
  placeholder = 'Select a document template...',
  ...props
}) => {
  const { data: templates, isLoading } = useDocumentTemplates();

  const templateOptions = React.useMemo(
    () =>
      (templates ?? []).map((template) => ({
        value: template.id,
        label: template.name,
      })),
    [templates],
  );

  return (
    <Select
      label={label}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      data={templateOptions}
      disabled={isLoading}
      clearable
      searchable
      {...props}
    />
  );
};
